import React from 'react';
import {Link, useParams} from "react-router-dom";
import './LinkCell.sass'
import pencilSVG from './pencil.svg'

function LinkCell2(props) {
    let {medId, orgName} = useParams()
    const {REACT_APP_URL_PREFIX} = process.env

    return (

      <>
        <div className='row__cell LinkCell'>
          <Link
            title={props.cellContent}
            to={REACT_APP_URL_PREFIX + `/counterAgents/MedCenterOrgList/${medId}/${orgName}/organizations/${props.idArr[0]}/${props.cellContent}`}>{props.cellContent}</Link>

        </div>
        <div onClick={_ => props.cellData.onClick(props.idArr[0])} className="editButton">
          <img src={pencilSVG} alt="open"/>
        </div>
      </>
    );
}

export default LinkCell2;